export const ATTACH_SURGICAL_REPORT_PATH = `request/surgical_report/attach_photos`;
